import { AppProvider } from 'contexts/AppContext'
import { AuthProvider } from './contexts/AuthContext'

import { BrowserRouter as Router, Routes } from 'react-router-dom'
import 'react-day-picker/style.css'
import './App.css'
import { ToastWrapper } from 'keep-react'
import { Header } from 'components/Header'
import { authRoutes, noAuthRoutes } from 'routes'

function App() {
  return (
    <AppProvider>
      <AuthProvider>
        <Router>
          <div className="h-screen w-screen flex flex-col">
            <Header />
            <Routes>
              {noAuthRoutes}
              {authRoutes}
            </Routes>
            <ToastWrapper
              duration={6000}
              expand={true}
              richColors={true}
              position="top-center"
              toastOptions={{
                classNames: {
                  title: 'text-body-3 font-medium',
                  toast: 'rounded-xl shadow-large',
                  description: 'text-body-4 font-normal',
                },
              }}
            />
          </div>
        </Router>
      </AuthProvider>
    </AppProvider>
  )
}

export default App
